export const errorSetEmptyFilters = (filters) =>{
    return {
        type: 'ERROR_SET_EMPTY_FILTERS',
        payload: filters
    }
}

export const errorEmptyParams = (status=true) => {
    return {
        type: 'ERROR_SET_EMPTY_PARAMS',
        payload: status
    }
}